import axios from "axios";
import moment from "moment";
export default {
  state: {
    contabili: [],
  },
  getters: {
    get_contabili: (state) => {
      return state.contabili;
    },
    get_contabile_by_id: (state) => (id) => {
      return state.contabili.find((contabile) => contabile.id == id);
    },
    get_contabile_by_id_ordine: (state) => (id_ordine) => {
      return state.contabili.find(
        (contabile) => contabile.id_ordine == id_ordine
      );
    },
    get_max_contabile_ddt: (state) => {
      // Ottieni l'anno corrente (ultime 2 cifre)
      const currentYear = moment().format("YY");
      let max_ddt = 0;
      
      state.contabili.forEach((contabile) => {
        if (contabile.ddt) {
          // le contabili sono salvate come numero/anno
          const parts = contabile.ddt.split("/");
          const ddt_num = parseInt(parts[0]);
          const ddt_year = parts[1];
          
          // Considera solo le contabili dell'anno corrente
          if (ddt_year === currentYear && ddt_num > max_ddt) {
            max_ddt = ddt_num;
          }
        }
      });
      
      // Restituisce il ddt maggiore trovato per l'anno corrente
      return max_ddt;
    },
    get_contabili_non_saldate_by_cliente: (state) => (cliente) => {
      return state.contabili.filter(
        (contabile) => contabile.cliente == cliente && !contabile.saldato
      );
    },
  },
  mutations: {
    set_contabili(state, contabili) {
      state.contabili = contabili;
    },
    set_contabile_eliminato(state, id) {
      let index = state.contabili.findIndex((contabile) => contabile.id == id);
      state.contabili.splice(index, 1);
    },
    add_contabile(state, contabile) {
      state.contabili.push(contabile);
    },
    update_contabile(state, contabile) {
      let index = state.contabili.findIndex((cont) => cont.id == contabile.id);
      if (index >= 0) {
        state.contabili.splice(index, 1, contabile);
      }
    },
    set_contabile_saldato(state, payload) {
      let contabile = state.contabili.find(
        (contabile) => contabile.id == payload.id
      );
      contabile.saldato = payload.stato;
    },
  },
  actions: {
    fetch_contabili(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/inizio/" +
        payload.inizio +
        "/fine/" +
        payload.fine;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((res) => {
            context.commit("set_contabili", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete_contabile(context, id) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, {
            auth: auth,
          })
          .then((response) => {
            context.commit("set_contabile_eliminato", id);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    create_contabile(context, contabile) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, contabile, {
            auth: auth,
          })
          .then((response) => {
            context.commit("add_contabile", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    toggle_contabile_saldato(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/" + payload.id + "/saldato";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(
            url,
            { stato: payload.stato },
            {
              auth: auth,
            }
          )
          .then((response) => {
            context.commit("update_contabile", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    update_contabile(context, contabile) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + contabile.id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, contabile, {
            auth: auth,
          })
          .then((response) => {
            context.commit("update_contabile", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SOCKET_CONTABILI_CHANGED(context) {
      context.dispatch("fetch_contabili", {
        inizio: moment().subtract(360, "days").format("X"),
        fine: moment().format("X"),
      });
    },
  },
};
